module.exports = __webpack_public_path__ + "img/page-banner-bg-5.92d92a33.jpg";